"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSCompanyInformationComponent = void 0;
// for b2b only: company information
const core_1 = require("@angular/core");
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const generic_content_service_1 = require("../../services/generic.content.service");
class CSCompanyInformationComponent {
    constructor(accountDetailService, modalService, genericContentService, accountService) {
        this.accountDetailService = accountDetailService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
    }
    open(content, options = { windowClass: 'dark-modal' }) {
        this.modelRef = this.modalService.open(content, options);
    }
    ngOnInit() {
        this.getCompanyInformationDetails();
        this.showForm = true;
        this.getErrorMessage();
    }
    getCompanyInformationDetails() {
        this.loader = true;
        this.accountDetailService.getCompanyInformation().subscribe((accountInfo) => {
            this.loader = false;
            this.companyInfo = accountInfo;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    submitCompanyInfo(value) {
        this.loader = true;
        this.error = null;
        const content = {
            'companyName': value.companyName,
            'mobile': value.mobileNumber,
            'companyUrl': value.companyUrl
        };
        this.accountDetailService.validateCompanyInformation(content)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.showForm = true;
            this.getCompanyInformationDetails();
            this.EditForm = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.showForm = true;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSCompanyInformationComponent = CSCompanyInformationComponent;
//# sourceMappingURL=companyinformation.component.js.map